import {JsonProperty} from '@hyperloris/tyson';

export class FieldRequest {
  @JsonProperty()
  search: string = '';
  @JsonProperty()
  search2: string = '';
  @JsonProperty()
  search3: string[] = [];
  @JsonProperty()
  search4: string[] = [];

  constructor(search_?: string, search2_?: string, search3_?: string[], search4_?: string[]) {
    this.search = search_;
    this.search2 = search2_;
    this.search3 = search3_;
    this.search4 = search4_;
  }

  static DEFAULT() {
    return new FieldRequest();
  }
}

